/**
 * Created by Ning Jiang on 2021-05-05.
 */

import {DDay} from "../DDay";
import {Layers} from "./DDayLayers";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {IFeatureData} from "../server/data/IBlitzKriegData";
import {TimelineLite, Power2, Linear} from "gsap";
import {DDayGameConfig} from "../DDayGameConfig";
import {DDaySymbol} from "../symbol/DDaySymbol";
import {BLEND_MODES} from "pixi.js";

export class DDayFeatureBackground extends PIXI.Container {
    private _bomberTopGFX: PIXI.spine.Spine[] = [];
    private _bomberTopContainer: PIXI.Container;
    private _bomberTopPosition: number[] = [-125, -100, -75, -100, -125];
    private _warFactoryGFX: PIXI.Sprite[] = [];
    private _warFactoryContainer: PIXI.Container;
    private _warFactoryPosition: number[] = [368, 224, 80, 80, 80];
    private _fighterLeftGFX: PIXI.Sprite[] = [];
    private _fighterLeftContainer: PIXI.Container;
    private _fighterLeftPositionX: number[] = [-177, -100, -100, 0, 80, 150, 225];
    private _fighterLeftPositionY: number[] = [398.5, 300, 200, 180, 120, 50, 0];
    private _fighterRightGFX: PIXI.Sprite[] = [];
    private _fighterRightContainer: PIXI.Container;
    private _fighterRightPositionX: number[] = [36.6, -24.4, -50, -170, -170, -250, -240];
    private _fighterRightPositionY: number[] = [630, 540, 423, 380, 280, 220, 160];
    private _panzerTankGFX: PIXI.Sprite[] = [];
    private _panzerTankContainer: PIXI.Container;
    private _tankContainer: PIXI.Container[] = [];
    private _artilleryGFX: PIXI.spine.Spine
    private _artilleryContainer: PIXI.Container;

    constructor() {
        super();
        this.init();
    }

    private init() {
        this._bomberTopContainer = new PIXI.Container();
        this._fighterLeftContainer = new PIXI.Container();
        this._fighterRightContainer = new PIXI.Container();
        this._panzerTankContainer = new PIXI.Container();
        this._warFactoryContainer = new PIXI.Container();
        this._artilleryContainer = new PIXI.Container();
        this._panzerTankContainer.position.set(-20, 118);
        this._fighterLeftContainer.position.set(-150, -150);
        this._fighterRightContainer.position.set(1000, -350);
        this.setAndCheckArtilleryPosition();
        for (let i: number = 0; i < 5; i++) {
            let bomber: PIXI.spine.Spine = new PIXI.spine.Spine(DDay.assetLoader.getSpineAsset("bomber"));
            bomber.position.x = (i * 144) + 72;
            bomber.position.y = this._bomberTopPosition[i];
            bomber.scale.set(0.3, 0.3);
            bomber.state.setAnimation(0, "normal", false);
            this._bomberTopGFX.push(bomber);
            this._bomberTopContainer.addChild(bomber);

            let tank: PIXI.Sprite = new PIXI.Sprite(DDay.assetLoader.getTextures("featureSymbols/panzer")[0]);
            tank.anchor.set(0.5, 0.5);
            if (i < 2) {
                tank.position.x = i === 0 ? 228 : 144;
            }
            tank.position.y = (i * 118);
            tank.scale.set(0.4, 0.4);
            tank.alpha = 0;
            let tankContainer: PIXI.Container = new PIXI.Container();
            tankContainer.addChild(tank);
            this._panzerTankGFX.push(tank);
            this._tankContainer.push(tankContainer);
            this._panzerTankContainer.addChild(tankContainer);

            let warFactory: PIXI.Sprite = new PIXI.Sprite(DDay.assetLoader.getTextures("featureSymbols/war_factory")[0]);
            warFactory.anchor.set(0.5, 0.5);
            warFactory.position.x = this._warFactoryPosition[i];
            warFactory.position.y = ((i + 1) * 118);
            warFactory.scale.set(0.7, 0.8);
            warFactory.alpha = 0;
            this._warFactoryGFX.push(warFactory);
            this._warFactoryContainer.addChild(warFactory);
        }

        for (let i: number = 0; i < 7; i++) {
            let fighter: PIXI.Sprite = new PIXI.Sprite(DDay.assetLoader.getTextures("featureSymbols/stuka")[0]);
            fighter.anchor.set(0.5, 0.5);
            fighter.position.x = this._fighterLeftPositionX[i];
            fighter.position.y = this._fighterLeftPositionY[i];
            fighter.scale.set(0.3, 0.3);
            fighter.tint = 0x555555;
            fighter.rotation = DDayGameConfig.degToRad(-50);
            this._fighterLeftGFX.push(fighter);
            this._fighterLeftContainer.addChild(fighter);

            let fighterRight: PIXI.Sprite = new PIXI.Sprite(DDay.assetLoader.getTextures("featureSymbols/stuka")[0]);
            fighterRight.anchor.set(0.5, 0.5);
            fighterRight.position.x = this._fighterRightPositionX[i];
            fighterRight.position.y = this._fighterRightPositionY[i];
            fighterRight.scale.set(0.3, 0.3);
            fighterRight.tint = 0x555555;
            fighterRight.rotation = DDayGameConfig.degToRad(50);
            this._fighterRightGFX.push(fighterRight);
            this._fighterRightContainer.addChild(fighterRight);
        }
        let artilleryGFX: PIXI.spine.Spine = new PIXI.spine.Spine(DDay.assetLoader.getSpineAsset("Artillery"));
        artilleryGFX.alpha = 0;
        artilleryGFX.visible = false;
        this._artilleryGFX = artilleryGFX;
        this._artilleryContainer.addChild(artilleryGFX);
        this.enableDisableFeatureGFX(false);
        NolimitApplication.getLayerByName(Layers.FEATURE_NON_ACTIVE)!.onResize = () => {
            this.onOrientationChanged();
        }
        NolimitApplication.getLayerByName(Layers.FEATURE_NON_ACTIVE)?.addChild(this._warFactoryContainer, this._bomberTopContainer, this._fighterLeftContainer,
            this._fighterRightContainer, this._artilleryContainer, this._panzerTankContainer);
    }

    public playStukaAnimation(featureInfo: IFeatureData): TimelineLite {
        let tl: TimelineLite = new TimelineLite();
        NolimitApplication.getLayerByName(Layers.FEATURE_ACTIVE)?.addChild(this._bomberTopContainer);
        tl.add(() => {
            this._bomberTopGFX.forEach((bomber: PIXI.spine.Spine, index: number) => {
                bomber.position.x = (index * 144) + 72;
                if (featureInfo.reels!.includes(index)) {
                    bomber.alpha = 1;
                    bomber.state.setAnimation(0, "normal", false);
                }
            });
        }, "beforeScaleUp");
        featureInfo.reels?.forEach((reel: number) => {
            this._bomberTopGFX[reel].scale.set(1, 1);
            tl.add(() => {
                this._bomberTopGFX[reel].tint = 0xFFFFFF;
            }, "scaleUp");
            tl.to(this._bomberTopGFX[reel], {
                y: 1000,
                duration: 2,
                ease: Power2.easeIn
            }, "start");
            tl.add(() => {
                this._bomberTopGFX[reel].y = this._bomberTopPosition[reel];
                this._bomberTopGFX[reel].scale.set(0.3, 0.3);
                this._bomberTopGFX[reel].alpha = 1;
                this._bomberTopGFX[reel].tint = 0x555555;
            }, "end")
        });
        tl.addLabel("beforeScaleUp");
        tl.addLabel("scaleUp");
        tl.addLabel("start");
        tl.addLabel("end");
        tl.add(() => {
            this._bomberTopGFX.forEach((bomber: PIXI.spine.Spine) => {
                bomber.alpha = 0;
            });
            NolimitApplication.getLayerByName(Layers.FEATURE_NON_ACTIVE)?.addChild(this._bomberTopContainer);
        });
        return tl;
    }

    public playFighterPlaneAnimation(featureInfo: IFeatureData): TimelineLite {
        let tl: TimelineLite = new TimelineLite();
        let offset = featureInfo.leftToRight ? 1 : -1;
        let fighterPlaneBulletsContainer: PIXI.Container = new PIXI.Container();
        let container: PIXI.Container = featureInfo.leftToRight ? this._fighterLeftContainer : this._fighterRightContainer;
        let gfxContainer: PIXI.Sprite[] = featureInfo.leftToRight ? this._fighterLeftGFX : this._fighterRightGFX;
        container.addChildAt(fighterPlaneBulletsContainer, 0);
        NolimitApplication.getLayerByName(Layers.FEATURE_ACTIVE)?.addChild(container);
        tl.add(() => {
            if (featureInfo.leftToRight) {
                this._fighterLeftGFX.forEach((fighter: PIXI.Sprite) => {
                    fighter.alpha = 1;
                });
            } else {
                this._fighterRightGFX.forEach((fighter: PIXI.Sprite) => {
                    fighter.alpha = 1;
                });
            }
        }, "beforeScaleUp");
        featureInfo.diagonals?.forEach((row: number) => {
            // Diagonal are changed, now it's from top to bottom.
            row = (6 - row);
            let fighterPlaneBullets: PIXI.spine.Spine = new PIXI.spine.Spine(DDay.assetLoader.getSpineAsset("fighterPlaneBullet"));
            let targetPosX: number = (featureInfo.leftToRight ? this._fighterLeftPositionX[row] : this._fighterRightPositionX[row]) + ((800 * 1.22) * offset);
            let targetPosY: number = (featureInfo.leftToRight ? this._fighterLeftPositionY[row] : this._fighterRightPositionY[row]) + (800);
            let bulletTargetPosX: number = targetPosX + (60 * 1.22 * offset)
            let bulletTargetPosY: number = targetPosY + 60;
            fighterPlaneBullets.position.set(gfxContainer[row].x + (60 * 1.22 * offset), gfxContainer[row].y + 60);
            let defaultBulletRotaion = DDayGameConfig.degToRad(90);
            fighterPlaneBullets.rotation = defaultBulletRotaion + gfxContainer[row].rotation;
            fighterPlaneBullets.scale.set(2, 2);
            fighterPlaneBulletsContainer.addChild(fighterPlaneBullets);
            fighterPlaneBullets.alpha = 0;
            tl.add(() => {
                gfxContainer[row].tint = 0xFFFFFF;
            }, "scaleUp");
            tl.to(gfxContainer[row].scale, {
                x: 1,
                y: 1,
                duration: 0.3,
                ease: Linear.easeIn
            }, "scaleUp");
            tl.add(() => {
                fighterPlaneBullets.state.setAnimation(0, "animation", true);
            }, "start");
            tl.to(gfxContainer[row], {
                x: targetPosX,
                y: targetPosY,
                duration: 2,
                ease: Power2.easeIn
            }, "start").to(fighterPlaneBullets, {
                alpha: 0
            }, ">-=0.5");
            tl.to([fighterPlaneBullets], {
                x: bulletTargetPosX,
                y: bulletTargetPosY,
                duration: 2,
                ease: Power2.easeIn
            }, "start").to(fighterPlaneBullets, {
                alpha: 1
            }, "<+=1");
            tl.to([gfxContainer[row], fighterPlaneBullets], {
                alpha: 0,
                duration: 0.2,
                ease: Linear.easeIn
            }, "fade")
            tl.add(() => {
                gfxContainer[row].y = featureInfo.leftToRight ? this._fighterLeftPositionY[row] : this._fighterRightPositionY[row];
                gfxContainer[row].x = featureInfo.leftToRight ? this._fighterLeftPositionX[row] : this._fighterRightPositionX[row];
                gfxContainer[row].scale.set(0.3, 0.3);
                gfxContainer[row].tint = 0x555555;
                gfxContainer[row].alpha = 1;
                fighterPlaneBullets.state.setAnimation(0, "animation", false);
                fighterPlaneBulletsContainer.removeChild(fighterPlaneBullets);
            }, "end")
        });
        tl.addLabel("beforeScaleUp");
        tl.addLabel("scaleUp");
        tl.addLabel("start");
        tl.addLabel("fade");
        tl.addLabel("end");
        tl.add(() => {
            NolimitApplication.getLayerByName(Layers.FEATURE_NON_ACTIVE)?.addChild(container);
            this._fighterLeftGFX.forEach((fighter: PIXI.Sprite) => {
                fighter.alpha = 0;
            });
            this._fighterRightGFX.forEach((fighter: PIXI.Sprite) => {
                fighter.alpha = 0;
            });
        });
        return tl;
    }

    public playTankAnimation(featureInfo: IFeatureData): TimelineLite {
        let tl: TimelineLite = new TimelineLite({
            onComplete: () => {
                this._panzerTankGFX.forEach((tank: PIXI.Sprite, idx: number) => {
                    this._tankContainer[idx].removeChildAt(0);
                    this._tankContainer[idx].mask = null;
                });
            }
        });
        NolimitApplication.getLayerByName(Layers.FEATURE_ACTIVE)?.addChild(this._panzerTankContainer);
        this._panzerTankGFX.forEach((tank: PIXI.Sprite, idx: number) => {
            let mask = new PIXI.Graphics();
            mask.beginFill(0x000000, 1);
            let symbolSize: number = (idx * 2) + 1;
            let width = (symbolSize > 5 ? 5 : symbolSize) * 144;
            mask.drawRect(tank.position.x - (idx > 0 ? 50 : 0), tank.position.y - 59, width + 70, 118);
            mask.endFill();
            this._tankContainer[idx].addChildAt(mask, 0);
            this._tankContainer[idx].mask = mask;
        });
        featureInfo.rows?.forEach((row: number) => {
            tl.add(() => {
                this._warFactoryGFX[row].alpha = 1;
            }, "scaleUp");
            tl.to(this._warFactoryGFX[row].scale, {
                x: 1,
                y: 1,
                duration: 0.3,
                ease: Linear.easeIn
            }, "scaleUp");
            tl.to(this._warFactoryGFX[row], {
                x: this._warFactoryPosition[row] - 155,
                duration: 0.3,
                ease: Linear.easeIn
            }, "scaleUp");
            tl.to(this._panzerTankGFX[row], {
                alpha: 1,
                duration: 0.05
            }, "showTank");
            tl.to(this._panzerTankGFX[row].scale, {
                x: 1,
                y: 1,
                duration: 0.3,
                ease: Linear.easeIn
            }, "scaleTank");
            tl.to(this._panzerTankGFX[row], {
                x: 1000,
                duration: 1.5,
                ease: Linear.easeNone
            }, "start");
            tl.to(this._warFactoryGFX[row].scale, {
                x: 0.7,
                y: 0.8,
                duration: 0.2,
                ease: Linear.easeIn
            }, "fade");
            tl.to(this._warFactoryGFX[row], {
                x: this._warFactoryPosition[row],
                duration: 0.2,
                ease: Linear.easeIn
            }, "fade");
            tl.add(() => {
                if (row < 2) {
                    this._panzerTankGFX[row].x = row === 0 ? 228 : 144;
                } else {
                    this._panzerTankGFX[row].x = 0;
                }
                this._panzerTankGFX[row].scale.set(0.4, 0.4);
                this._panzerTankGFX[row].alpha = 0;
                this._warFactoryGFX[row].alpha = 0;
            }, "end");
        });
        tl.addLabel("scaleUp");
        tl.addLabel("showTank");
        tl.addLabel("scaleTank");
        tl.addLabel("start");
        tl.addLabel("fade");
        tl.addLabel("end");
        tl.add(() => {
            NolimitApplication.getLayerByName(Layers.FEATURE_NON_ACTIVE)?.addChild(this._panzerTankContainer);
        });
        return tl;
    }

    public playArtilleryAnimation(featureInfo: IFeatureData): TimelineLite {
        let tl: TimelineLite = new TimelineLite();
        let artilleryFireAnim: TimelineLite = DDay.createTimelineForAnimation(this._artilleryGFX, 0, "fire_2", false, 1);
        let artilleryShowAnim: TimelineLite = DDay.createTimelineForAnimation(this._artilleryGFX, 0, "show", false, 1);
        this._artilleryGFX.visible = true;
        tl.add(artilleryShowAnim);
        tl.add(() => {
            NolimitApplication.getLayerByName(Layers.FEATURE_ACTIVE)?.addChild(this._artilleryContainer);
        });
        tl.add(artilleryFireAnim);
        return tl;
    }

    public playArtilleryHideAnimation(): TimelineLite {
        let tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            NolimitApplication.getLayerByName(Layers.FEATURE_NON_ACTIVE)?.addChild(this._artilleryContainer);
        });
        let artilleryHideAnim: TimelineLite = DDay.createTimelineForAnimation(this._artilleryGFX, 0, "hide", false, 1);
        tl.add(artilleryHideAnim);
        return tl;
    }

    public disableArtillery(): TimelineLite {
        let tl: TimelineLite = new TimelineLite();
        tl.fromTo(this._artilleryGFX, {
            alpha: 1
        }, {
            alpha: 0,
            duration: 0.2,
            ease: Power2.easeOut
        });
        return tl;
    }

    public onOrientationChanged(): void {
        // TODO: check restore, mode, orientation
        this.setAndCheckArtilleryPosition();
    }

    private setAndCheckArtilleryPosition(): void {
        if (NolimitApplication.isLandscape) {
            this._artilleryContainer.rotation = DDayGameConfig.degToRad(0);
            this._artilleryContainer.position.set(640, 482);
        } else {
            this._artilleryContainer.rotation = DDayGameConfig.degToRad(270);
            this._artilleryContainer.position.set(360, 148);
        }
    }

    public enableDisableFeatureGFX(isEnable: boolean = true): void {
        this._bomberTopGFX.forEach((bomberGFX: PIXI.spine.Spine) => {
            bomberGFX.alpha = isEnable ? 1 : 0;
        });

        this._fighterRightGFX.forEach((fighterGFX: PIXI.Sprite) => {
            fighterGFX.alpha = isEnable ? 1 : 0;
        });

        this._fighterLeftGFX.forEach((fighterGFX: PIXI.Sprite) => {
            fighterGFX.alpha = isEnable ? 1 : 0;
        });
    }

    public blastBomber(reelId: number) {
        let bomber: PIXI.spine.Spine = this._bomberTopGFX[reelId];
        let tl: TimelineLite = new TimelineLite();
        let xPosition: number = bomber.x;
        let durr: number = bomber.spineData.findAnimation("explode").duration;
        tl.add(() => {
            bomber.state.setAnimation(0, "explode", false);
        });
        tl.to(bomber, {
            x: xPosition - (reelId < 3 ? 80 : -80),
            duration: 0.5
        });
        tl.to(this, {duration: durr});
    }

    public onResize() {
        // TODO: check restore, mode, orientation
    }
}
